import styled from '@emotion/styled';

export const SkeletonsWrapperStyled = styled.div`
  width: 100%;
  gap: 22px;
  display: flex;
  flex-direction: column;
  margin-top: 22px;
`;
